<form class="flex w-full flex-col gap-12" [formGroup]="formGroup" (ngSubmit)="clickSubmit()">
    <div class="flex w-full flex-col gap-2">
        <mat-form-field appearance="outline" niceControlStatus>
            <mat-label>{{ "features.register.form.email" | translate }}</mat-label>
            <input type="email" formControlName="email" matInput />
        </mat-form-field>

        <mat-form-field class="w-full" appearance="outline" niceControlStatus>
            <mat-label>{{ "features.register.form.password" | translate }}</mat-label>
            <input [type]="showPasswordInputType()" formControlName="password" matInput />

            <button
                tabindex="-1"
                matButtonIcon
                matIconSuffix
                (click)="showPassword.set(!showPassword())"
            >
                @if (!showPassword()) {
                    <mat-icon svgIcon="streamline-regular:view-1" />
                } @else {
                    <mat-icon svgIcon="streamline-regular:close-eyes" />
                }
            </button>
        </mat-form-field>

        <mat-form-field class="w-full" appearance="outline" niceControlStatus>
            <mat-label>{{ "features.register.form.confirm_password" | translate }}</mat-label>
            <input [type]="showConfirmPasswordInputType()" formControlName="confirmPassword" matInput />

            <button
                tabindex="-1"
                matButtonIcon
                matIconSuffix
                (click)="showConfirmPassword.set(!showConfirmPassword())"
            >
                @if (!showConfirmPassword()) {
                    <mat-icon svgIcon="streamline-regular:view-1" />
                } @else {
                    <mat-icon svgIcon="streamline-regular:close-eyes" />
                }
            </button>
        </mat-form-field>

        <section>
            <div
                *resolve="has8Characters$ | async as has8Characters"
                class="flex items-center gap-4 opacity-30"
                [class]="has8Characters | nerriPasswordRuleClass"
            >
                <mat-icon class="stroke-1 icon-size-4" [svgIcon]="has8Characters | nerriPasswordRuleIcon" />
                <span>{{ "features.register.form.password_rules.minlength" | translate }}</span>
            </div>

            <div
                *resolve="has1UppercaseLetter$ | async as has1UppercaseLetter"
                class="flex items-center gap-4 opacity-30"
                [class]="has1UppercaseLetter | nerriPasswordRuleClass"
            >
                <mat-icon class="stroke-1 icon-size-4" [svgIcon]="has1UppercaseLetter | nerriPasswordRuleIcon" />
                <span>
                    {{ "features.register.form.password_rules.must_have_1_uppercase_letter" | translate }}
                </span>
            </div>

            <div
                *resolve="has1LowercaseLetter$ | async as has1LowercaseLetter"
                class="flex items-center gap-4 opacity-30"
                [class]="has1LowercaseLetter | nerriPasswordRuleClass"
            >
                <mat-icon class="stroke-1 icon-size-4" [svgIcon]="has1LowercaseLetter | nerriPasswordRuleIcon" />
                <span>
                    {{ "features.register.form.password_rules.must_have_1_lowercase_letter" | translate }}
                </span>
            </div>

            <div
                *resolve="has1Number$ | async as has1Number"
                class="flex items-center gap-4 opacity-30"
                [class]="has1Number | nerriPasswordRuleClass"
            >
                <mat-icon class="stroke-1 icon-size-4" [svgIcon]="has1Number | nerriPasswordRuleIcon" />
                <span>{{ "features.register.form.password_rules.must_have_1_number" | translate }}</span>
            </div>

            <div
                *resolve="has1Symbol$ | async as has1Symbol"
                class="flex items-center gap-4 opacity-30"
                [class]="has1Symbol | nerriPasswordRuleClass"
            >
                <mat-icon class="stroke-1 icon-size-4" [svgIcon]="has1Symbol | nerriPasswordRuleIcon" />
                <span>{{ "features.register.form.password_rules.must_have_1_symbol" | translate }}</span>
            </div>
        </section>
    </div>

    <button class="w-full" mat-flat-button color="accent" [disabled]="saving" (click)="clickSubmit()">
        <div class="flex justify-center" *ngIf="saving; else savingText">
            <mat-spinner [diameter]="24"></mat-spinner>
        </div>

        <ng-template #savingText>
            <span>{{ "features.register.create_account" | translate }}</span>
        </ng-template>
    </button>
</form>
